import { cn } from '../../utils/cn';

/**
 * Table primitives (ds/table).
 */
export function Table({ className, children, ...props }) {
  return (
    <div
      data-ds-id="ds/table"
      className={cn(
        'overflow-hidden rounded-ds-lg border border-border bg-card',
        className,
      )}
    >
      <div className="overflow-x-auto">
        <table className="w-full text-type-body-sm" {...props}>
          {children}
        </table>
      </div>
    </div>
  );
}

export function TableHeader({ className, ...props }) {
  return (
    <thead
      className={cn('sticky top-0 z-10 bg-muted', className)}
      {...props}
    />
  );
}

export function TableBody({ className, ...props }) {
  return <tbody className={className} {...props} />;
}

export function TableRow({ className, ...props }) {
  return (
    <tr
      className={cn('border-t border-border hover:bg-muted/80', className)}
      {...props}
    />
  );
}

export function TableHead({ className, ...props }) {
  return (
    <th
      className={cn(
        'px-space-4 py-space-3 text-left text-type-label font-semibold tracking-wide text-muted-foreground',
        className,
      )}
      {...props}
    />
  );
}

export function TableCell({ className, ...props }) {
  return (
    <td className={cn('px-space-4 py-space-3 text-foreground', className)} {...props} />
  );
}

export function TableFooter({ className, children }) {
  return (
    <div
      className={cn(
        'flex items-center justify-between border-t border-border bg-muted px-space-4 py-space-3 text-type-body-sm text-muted-foreground',
        className,
      )}
    >
      {children}
    </div>
  );
}
